import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=3cf1c0fd&scoped=true&"
import script from "./HomeProfile.vue?vue&type=script&lang=js&"
export * from "./HomeProfile.vue?vue&type=script&lang=js&"
import style0 from "./HomeProfile.vue?vue&type=style&index=0&id=3cf1c0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf1c0fd",
  null
  
)

export default component.exports